// extracted by mini-css-extract-plugin
export default {"ButtonMore":"ButtonMore_ButtonMore__+G55W","dropDown":"ButtonMore_dropDown__h2lVY","editIcon":"ButtonMore_editIcon__g4IQl","button":"ButtonMore_button__CGBBu"};